<template>
  <div>
    <vs-card class="email-card">
      <div class="flex flex-wrap justify-between items-center">
        <div class="md:w-1/2 w-full p-1">
          <vs-input
              placeholder="Search"
              class="w-full"
              v-model="search"
              @keyup="searchFun"
              style="width: 100%"
            />
        </div>
        <vs-button
          @click="emailTemplate = true"
          type="filled"
          v-if="checkCreatePermission()"
          >Create Template</vs-button
        >
      </div>
      <vs-button
        color="danger"
        v-if="selected.length > 1 && checkDeletePermission()"
        @click="templateDeletePopup1"
        type="filled"
        >Bulk Delete</vs-button
      >
      <vs-tabs>
        <vs-tab label="" icon-pack="feather" icon="icon-inbox">
          <ag-grid-vue
            ref="agGridTable"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            @row-selected="CellvalueSelectDeselect"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="templateList"
            rowSelection="multiple"
            colResizeDefault="true"
            :animateRows="true"
            :floatingFilter="false"
            :pagination="true"
            :suppressPaginationPanel="true"
            :enableRtl="$vs.rtl"
            :style="{ minHeight: query_page.limit * 48 + 75 + 'px' }"
            :paginationPageSize="paginationPageSize"
            @grid-ready="onGridReady"
            @sortChanged="sortFun"
          >
          </ag-grid-vue>
          <div>
            <ItemsPerTableDropdown
              tableName="email_template"
              @change="(pageLimit) => pageLimitSet = pageLimit"
            />
            <pagination
              :meta="query_page"
              @page-change="handlePageChange"
              class="cstm_pagination"
              style="float: right"
            />
          </div>
        </vs-tab>
      </vs-tabs>

      <div class="full-cstm-sidebar mt-107" :class="{ open: emailSidebar }">
        <div class="mt-6 flex items-center justify-between px-6">
          <h4>
            <span v-if="editTemplateId">Edit</span>
            <span v-else>Create</span> Email Template
          </h4>
          <feather-icon
            icon="XIcon"
            class="cursor-pointer"
            @click="handlcreateSidebar"
          />
        </div>
        <vs-divider class="mb-0" />

        <div class="p-6 pt-2 sidebar-scrollable-form">
          <div class="mb-4">
            <label>Platform Modules</label>
            <v-select
              v-model="templateData.platform_modules_id"
              v-validate="'required'"
              :reduce="(option) => option.platform_modules_id"
              label="module_name"
              name="module_name"
              :options="platformModuleslistArr"
              @input="getCommunicationTypeList()"
              style="width: 100%"
            />
          </div>

          <div class="mb-4">
            <label>Module Actions</label>
            <v-select
              class="w-full"
              label="entity_name"
              :options="communicationTypeListArrList"
              :reduce="(option) => option.role_action_id"
              v-model="templateData.type_id"
              name="Module Actions"
              data-vv-name="Module Actions"
            ></v-select>
          </div>

          <div class="mb-4">
            <vs-textarea
              class="w-full mt-5"
              placeholder="Write a Subject Line"
              v-model="templateData.subject"
            />
          </div>

          <div class="mb-4">
            <editor
              :api-key="tinyMceApi"
              v-model="templateData.template"
              :init="initTinyMce"
            />
          </div>

          <vs-row vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="1"
            >
              <vs-checkbox
                v-model="templateData.is_default"
                class="mt-5 w-full"
                vs-value="1"
              ></vs-checkbox>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="11"
            >
              <label class="mt-5 w-full">Default</label>
            </vs-col>
          </vs-row>

          <vs-button
            v-if="editTemplateId"
            class="mt-4"
            :disabled="!buttonActive"
            @click="createTemplate"
            >Update</vs-button
          >

          <vs-button
            v-if="!editTemplateId"
            class="mt-4"
            :disabled="!buttonActive"
            @click="createTemplate"
            >Save</vs-button
          >
          <br />
          <br />
          <vs-divider />
          <label>Codes with Description</label>
          <small>(Click to append)</small>
          <vs-divider />
          <div class="flex flex-wrap">
            <div
              class="outer-field-cstm-badge sm:w-1/2 w-full"
              style="padding: 0 5px"
              :key="index"
              v-for="(item, index) in attachICSFile"
            >
              <div class="field-cstm-badge">
                <a @click="appendCodeToTemplate(item.field_code)">{{
                  item.field_description
                }}</a>
                <a class="info"><span class="material-icons">info</span></a>
                <p class="description">{{ item.field_description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-overlay"></div>

      <!-- View -->
      <vs-sidebar
        click-not-close
        position-right
        parent="body"
        :hidden-background="true"
        default-index="1"
        color="primary"
        class="sidebarx cstm-sidebarx email-sidebar"
        spacer
        v-model="emailViewSidebar"
      >
        <div class="mt-6 flex items-center justify-between px-6">
          <h4>Template Details</h4>
          <feather-icon
            icon="XIcon"
            class="cursor-pointer"
            @click="handleViewSidebar"
          />
        </div>
        <vs-divider class="mb-0" />

        <div class="p-6 pt-2 sidebar-scrollable-form">
          <vs-row vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="6"
            >
              <h6>Platform Module:</h6>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="6"
            >
              <p>{{ ViewtemplateData.platform_module }}</p>
            </vs-col>
          </vs-row>
          <vs-divider />

          <vs-row vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="6"
            >
              <h6>Platform Module Action:</h6>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="6"
            >
              <p>{{ ViewtemplateData.platform_module_action }}</p>
            </vs-col>
          </vs-row>
          <vs-divider />

          <vs-row vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="6"
            >
              <h6>Template:</h6>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="6"
            >
              <p v-html="this.ViewtemplateData.template"></p>
            </vs-col>
          </vs-row>
          <vs-divider />

          <vs-row vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="6"
            >
              <h6>Subject:</h6>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="6"
            >
              <p v-html="this.ViewtemplateData.subject"></p>
            </vs-col>
          </vs-row>

          <vs-row>
            <p class="mt-4"></p>
          </vs-row>
        </div>
      </vs-sidebar>
    </vs-card>
    <vs-popup title="Please confirm" :active.sync="deletepopupflag">
      <vs-row>
        <span>Are you sure to delete this template?</span>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button
          @click="deleteTemplate"
          color="red"
          type="filled"
          class="mr-2 vs-con-loading__container"
          >Accept</vs-button
        >
        <vs-button @click="cancelDeletePopup" type="border">Cancel</vs-button>
      </vs-row>
    </vs-popup>
    <vs-popup title="Please confirm" :active.sync="deletepopupflag1">
      <vs-row>
        <span>Are you sure to delete templates?</span>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button
          @click="templateBulkDelete"
          color="red"
          type="filled"
          class="mr-2 vs-con-loading__container"
          >Accept</vs-button
        >
        <vs-button @click="cancelMultipleDeletePopup" type="border"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <div v-if="emailTemplate">
      <emailTemplatePopup :emailTemplate="emailTemplate" :type="type" :template_details="template_details" @closeEmailTempalatePopup="closeEmailTempalatePopup" />
    </div>
  </div>
</template>

  <!-- TinyMCE CDN -->
<script src="https://cdn.tiny.cloud/1/dby84f0rwttg363c3yyx0t5jucrrxd2rsclfsoi76uhjy4ez/tinymce/5/tinymce.min.js" referrerpolicy="origin"></script>

<script>
import emailTemplatePopup from '@/views/pages/email/emailTemplatePopup.vue'

import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import Bell from "./Bell";
import Editor from "@tinymce/tinymce-vue";
import vSelect from "vue-select";
import { contentFileUpload } from "@/api/course-builderapi";
import {
  emailDynamicFieldList,
  emailTemplateList,
  emailTypeList,
  emailTemplateCreate,
  emailTemplateDelete,
  emailTemplateShow,
  emailTemplateEdit,
  platformModuleslist,
  communicationTypeList,
  notifiable_platform_modules,
} from "@/api/email.js";
import { PermissionMiddleware } from "../../../mixins/middleware/PermissionMiddleware";
import Pagination from "@/components/common/pagination";

import ImportBrowseFilesModel from "@/components/common/ImportBrowseFilesModel.vue";
import { GoogleAuthorization } from "@/mixins/common/GoogleAuthorization.js";
import { getRepositoryDetails } from "@/api/message";
import { getUploadedFilesId } from "@/api/assignment-question";
import TemplateActionCell from "./TemplateActionCell.vue"

export default {
  name: "Email",
  components: {
    Bell,
    editor: Editor,
    vSelect,
    Pagination,
    AgGridVue,
    TemplateActionCell,
    emailTemplatePopup,
  },
  mixins: [PermissionMiddleware, GoogleAuthorization],

  data() {
    return {
      template_details:null,
      emailTemplate:false,
      search:'',
      defaultColDef: {
        suppressMenu: false,
        editable: true,
        sortable: true,
        resizable: true
        // autoHeight: true
      },
      initTinyMce: {
        setup: (editor) => {
          editor.ui.registry.addIcon(
            "filesIcon",
            '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>'
          );

          editor.ui.registry.addIcon(
            "gDriveIcon",
            '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>'
          );

          editor.ui.registry.addButton("gDrive", {
            icon: "gDriveIcon",
            tooltip: "Insert from GDrive",
            onAction: () => {
              this.gDrive(editor);
            },
          });
        },
        height: 500,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.example_image_upload_handler,
        plugins: [
          "autolink lists link image charmap print preview anchor",
          "imagetools",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount",
          "code lists fullscreen",
          "emoticons",
        ],
        menu: "table",
        toolbar:
          "customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor | \
                        table alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help",
      },
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      editorComponent: null,
      file_repository_id: "",
      view_template_data: "",
      role_action_id: "",
      communicationTypeListArr: [],
      platformModuleslistArr: [],
      tinyMceApi: "",
      typeOfEmailTemplate: "",
      editTemplateId: null,
      detailsView: [],
      emailViewSidebar: false,
      emailEditSidebar: false,
      image_url: "",
      deletepopupflag: false,
      deletepopupflag1: false,
      deleteTemplateId: "",
      type: "Create",
      templateData: {},
      ViewtemplateData: {
        platform_module: "",
        platform_module_action: "",
        subject: "",
        template: "",
        is_default: "",
      },
      emailType: [],
      attachICSFile: [],
      checkBox1: "",
      selected: [],
      log: [],
      emailSidebar: false,
      templateList: [],
      query_page: {
        total: "",
        limit: 10,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: "",
      },
      pageLimitSet: null,
      gridApi: {},
      gridOptions: {
        accentedSort: true
      }
    };
  },
  created() {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API;
    const customer_id = localStorage.getItem("customer_id");
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL;
    this.image_url = `${imageUploadUrl}${customer_id}`;
    //checking Permission
    const role_permission = localStorage.getItem("role_permission");
    if (role_permission == 1) {
      this.schoolAdmin = true;
    } else {
      this.schoolAdmin = false;

      this.getModulePermission("Communication", "email");
    }

    this.columnDefs = [
      {
        headerName: '',
        width: 60,
        field: 'isSelected',
        filter: false,
        sortable: false,
        checkboxSelection: (params) => {
          return true
        },
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true
      },
      {
        headerName: 'Subject',
        field: 'subject',
        width: 800
      },
      {
        headerName: 'Description',
        field: 'body',
        width: 800,
        valueGetter: (param) => {
          return param.data.body ? this.decodeHtml(this.getPlainText(param.data.body)) : ''
        }
      },
      {
        headerName: 'Module',
        field: 'module',
        width: 300,
        valueFormatter: (params) => params.data.platform_module?params.data.platform_module.module_name:''
      }
    ]

    if (this.checkEditPermission() || this.checkDeletePermission()) {
      this.columnDefs.push({
        headerName: 'Action',
        field: 'action',
        sortable: false,
        cellRendererFramework: Vue.extend(TemplateActionCell),
        CellRendererParams: {
          templateEditSidebar: (data) => this.templateEditSidebar(data),
          templateDeletePopup: (id) => this.templateDeletePopup(id),
          checkEditPermission: () => this.checkEditPermission(),
          checkDeletePermission: () => this.checkDeletePermission()
        }
      })
    }
  },
  computed: {
    communicationTypeListArrList() {
      this.communicationTypeListArr = this.communicationTypeListArr.filter(
        (element) => {
          if (element.action_name != "LeadActivity") return element;
        }
      );
      return this.communicationTypeListArr;
    },
    buttonActive() {
      if (
        this.templateData.type_id !== null &&
        this.templateData.template !== "" &&
        this.templateData.subject !== ""
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    this.getRepositoryDetails();
    //this.notifiable_platform_modules()
    this.getPlatformModuleslist();

  },
  watch: {
    pageLimitSet () {
      this.handlePageChange(1)
    }
  },
  methods: {
    decodeHtml (html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    },
    getPlainText (htmlString) {
      let htmlStringPlain = htmlString.replace(/<[^>]+>/g, '').replace(/&nbsp;/g,'').slice(0, 25)
      if (htmlStringPlain === '') {
        if (htmlString.includes('<img')) {
          return this.getImageIcon()
        } else {
          return subject
        }
      } else {
        htmlStringPlain = `${htmlStringPlain}`
        if (htmlStringPlain.length <= 24) {
          return htmlStringPlain
        } else {
          return `${htmlStringPlain}...`
        }
      }
    },
    getImageIcon () {
      return '<img style="width:40px" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAEQklEQVRoge2YS2wbVRSGvztj52k7TYjUpmqLShIhFlCxAolFV9BVsuiGDaxYswAkoKsWVGilSokaFCS2DRWEAKIEWKRIICEEK6SqQaXk4ZrEwXnaseOMPa/LYhIn8YzbsVvngfwtLN9zzp17/jn3zB0batSoUaPGQyC8jGdff/uYIgL9wBkgvLspucgguCml8u5XAxcnip0uARvJ3wLadiU9/6wIVTwz0v9BfLsxUBy1cefbnu5+gld6XqQ1srcFSKYzDI2OMT4RbZOW7ANe3u5XPOacAfZF8gCtkTCv9rzkDIST23a8BIQ3J+4XCrlIWop9XgIOFK4eKMULvzdUMw8Xvz6f8xV34Ctw4AX43kJdIQBB1oKlvMSw3TFBBdrrBc2qRCLQLFgsEQtwunWCC52jSAHnJ3v5JdlVtgDfFVCEQBEQDsCJJsHRRkFXSNDZLDjSKGjasIcDTqwqILRhC3qc93UKvN89yuH6NEfq0lzsHvWMexC+K7CdzeQAEBBRIBLwXl0VcLxJIAQgIWtD2pB0NIgdd08AjzcLJOB8+mNXeiCgOEJUBSIBONboVGhwtpdlI8KS0cLHsz0owolThP9SVFQBaS6hzb0HAho7ziMC7ZVchj8y3bx2562K5m5SvgApyS1cxTZmAFCW+zn15IfotsJczialb5W/QYWjjQrhgLN/MgbENZt8iaauBN8Cnoqo1Ktwb+5r1rTbBXtm7U/iC99w/PBZTjYrrAYloSBIKQpbwkFwqA7CQYW4JmmvE9SrgpwtSWiSVcMR3hKEjgb/O9u3gEYVsto/zCWuu3yx+Ke0hp8l1HSSQ3ViM19PVCE40bTlbFYFnSGBDeQtZ51y8C3Vtg3+mr6CbevevugVLOn26eYy47E3uB17E91cvm8i5Sa/Oc8X0fg1stq9kv51bYbY7NBOo5REE4NoepycPst0YgDJI2wAyhAQX7jxwJjZhRuk0rcK40RqlLQ2XhhntDvMp75zzbOsFAuLl5hfvIxlpfymBJRzDkgfh4uU3I32YZoZNH2G+MqwKyS+NMx6PrZjTjJ1HcOcxzQTJFNDZVXpkR9keWOFu7GPmPp3ANs2XH5bGkwlrmJv9Mva+k/k9a3f6nl9irXsz77Xq8pJvJz8jUx2uqQ/p88SX/4cw5wjnfnB5c942EpR0UnsB0MzUFUFoXg/TxOp75HGBCqmyyel21aK6r0LSYmuuR+r2/1L2UlsP711H6r6MmebNma+9N20pEUqn3yoNar+NmrkDWyr9FMlZ+bQTK3i61f/dVqCoenOlxKs5lNY0qro8r6beKT3s4oWqDYH/ke9l4A0OP9J7hcKuQhWi31uAYIfAYZGx/aFiGQ6w7Vvx5yB5Gax39UDqinPWao4PT4Rfeydvk+qn6F/VoRqnys2uiowPHjpb6GKU8AXbGynPSYNfClU+7mR/suTe51MjRo1avzP+A949qQ11PGB5gAAAABJRU5ErkJggg=="/>'
    },
    closeEmailTempalatePopup () {
      this.emailTemplate = false
      this.handlePageChange(1)
      this.type = 'Create'
    },
    searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        vm.handlePageChange(1)
      } catch (e) {
        console.log(e)
      }
    }, 1000),
     async sortFun () {
        try {
        const sortState = this.gridOptions.api.getSortModel()
        if (sortState.length >0) {
          this.sorting_obj.field_type ='system'
          this.sorting_obj.attribute = sortState[0].colId
          this.sorting_obj.direction = sortState[0].sort
        } else {
          this.sorting_obj.field_type =''
          this.sorting_obj.attribute = ''
          this.sorting_obj.direction = ''
        }
          this.handlePageChange(1)
        } catch (e) {

        }
     },
    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)

      return selectedData
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api

      const selectedNodes = this.gridApi.getSelectedNodes()
      //
      if (selectedNodes) {
        //
        const selecttedNode = this.gridApi.getSelectedNodes()
        this.selected = selecttedNode.map((node) => node.data)
      } else {
        this.selected = []
      }
    },
    async getRepositoryDetails() {
      const payload = {
        platform_module_id: "39",
      };
      const customer_id = localStorage.getItem("customer_id");
      const data = await getRepositoryDetails(customer_id, payload);
      //
      //
      this.file_repository_id = data.data.data[0].id;
    },
    gDrive(editor) {
      this.editorComponent = editor;
      this.driveIconClicked();
    },
    getImportFile({ file_id, fileInfo }) {
      fileInfo.forEach((eachFile) => {
        this.editorComponent.insertContent(
          `<img src="${eachFile.file_path}" width="auto" height="auto"/>`
        );
      });
      setTimeout(() => {
        this.isBrowseContent = false;
        this.showSuccessMessage(
          "Success",
          "File Imported Successfully",
          "success"
        );
      }, 0);
    },
    async getUploadFiles(file_id_payload, type = "system") {
      const res = await getUploadedFilesId(file_id_payload);

      // console.log()
      const filesDriveInfo = res.data.data.files;
      if (type === "drive") {
        filesDriveInfo.forEach((eachFile) => {
          if (eachFile.file_type.split("/")[0] === "image") {
            this.editorComponent.insertContent(
              `<img src="${eachFile.file_path}" width="200" height="200"/>`
            );
          } else if (eachFile.file_type.split("/")[0] === "video") {
            this.editorComponent.insertContent(
              `<video width="200" height="300"<source src="${eachFile.file_path}"</video>`
            );
          } else if (eachFile.file_type.split("/")[0] === "audio") {
            this.editorComponent.insertContent(
              `<img src="${eachFile.file_path}" width="200" height="200"/>`
            );
          }
        });
        console.log(filesDriveInfo);
      }
    },
    async notifiable_platform_modules() {
      try {
        const { data } = await notifiable_platform_modules();
        // console.log(data)
      } catch (e) {}
    },
    handlePageChange(page) {
      if (!this.pageLimitSet) return
      this.$vs.loading()
      this.selected.length = 0;
      this.query_page.current_page = page;
      const payload = {
        search:this.search
      }
      // this.fetchQuestionBankList()
      emailTemplateList(
        this.sorting_obj,
        'email_template',
        payload,
        localStorage.getItem("customer_id"),
        this.query_page.current_page,
        this.pageLimitSet
      )
        .then((res) => {
          this.templateList = res.data.data.template;
          this.query_page = res.data.data.meta;
          this.$vs.loading.close()
        })
        .catch((e) => {});
    },
    async getPlatformModuleslist() {
      const data = await platformModuleslist();
      this.platformModuleslistArr = data.data.data.modules_list;
      //
    },
    async getCommunicationTypeList() {
      //this.templateData.type_id = null
      const customer_id = localStorage.getItem("customer_id");
      const data = await communicationTypeList(
        customer_id,
        this.templateData.platform_modules_id
      );

      this.communicationTypeListArr = data.data.data.types;

      this.getCommunicationDynamicField();
      //
    },
    async getCommunicationDynamicField() {
      try {
        //this.templateData.type_id = null
        const customer_id = localStorage.getItem("customer_id");
        const platform_modules_id = this.templateData.platform_modules_id;
        const { data } = await emailDynamicFieldList(
          platform_modules_id,
          customer_id
        );
        this.attachICSFile = data.data.email_dynamic_field_list;
      } catch (e) {
        console.error(e);
      }
    },
    appendCodeToTemplate(field_code) {
      // eslint-disable-next-line no-undef
      tinymce.activeEditor.execCommand("mceInsertContent", false, field_code);
      // this.templateData.template += ` ${field_code}`
      this.$vs.notify({
        title: "Success",
        text: "Code added",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
        time: 2000,
      });
    },
    images_upload_handler(blobInfo, success, failure) {
      const xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      xhr.open("POST", this.image_url);

      xhr.upload.onprogress = function (e) {
        progress((e.loaded / e.total) * 100);
      };

      xhr.onload = function () {
        // let json

        if (xhr.status === 403) {
          failure(`HTTP Error: ${xhr.status}`, { remove: true });
          return;
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          failure(`HTTP Error: ${xhr.status}`);
          return;
        }

        const json = JSON.parse(xhr.responseText);

        if (!json || typeof json.location !== "string") {
          failure(`Invalid JSON: ${xhr.responseText}`);
          return;
        }

        success(json.location);
      };

      xhr.onerror = function () {
        failure(
          `Image upload failed due to a XHR Transport error. Code: ${xhr.status}`
        );
      };

      xhr.setRequestHeader(
        "Authorization",
        `Bearer ${JSON.parse(localStorage.getItem("access_token"))}`
      );

      const formData = new FormData();
      formData.append("files[0]", blobInfo.blob(), blobInfo.filename());

      xhr.send(formData);
    },
    example_image_upload_handler(blobInfo, success, failure, progress) {
      const formData = new FormData();
      formData.append("files[0]", blobInfo.blob());

      const data = this.fileupload(formData);

      data
        .then((res) => {
          const locationObject = {
            src: {
              value: {
                location: res,
              },
            },
          };

          const stringify = JSON.stringify(res);
          const parse = JSON.parse(stringify);

          success(parse);
        })
        .catch((error) => {});
    },

    async fileupload(payload) {
      try {
        const customer_id = localStorage.getItem("customer_id");

        const responseImage = await contentFileUpload(customer_id, payload);
        const location =
          responseImage.data.data.cdn +
          responseImage.data.data.files[0].file_path;
        this.$vs.notify({
          title: "Success",
          text: "Image Uploaded Successfully",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          time: 3000,
        });
        return location;
      } catch (error) {}
    },

    handlcreateSidebar() {
      this.emailSidebar = false;
      this.resetData();
    },
    handleEditSidebar() {
      this.emailEditSidebar = false;
      this.selected.length = 0;
      this.templateData.type_id = null;
      this.templateData.subject = "";
      this.templateData.template = "";
      this.templateData.is_default = "";
    },
    templateEditSidebar(edit_template_Data) {
      console.log(edit_template_Data);
      this.type='Edit'
      this.templateData = edit_template_Data
      this.template_details = edit_template_Data

      this.emailTemplate = true;
    },
    handleViewSidebar() {
      this.emailViewSidebar = false;
      this.selected.length = 0;
    },
    getSelectedRows() {
      return this.selected;
    },
    resetData() {
      this.templateData.type_id = null;
      this.templateData.subject = "";
      this.templateData.template = "";
      this.templateData.is_default = "";
      this.templateData.platform_modules_id = "";
      this.editTemplateId = null;
    },
    createTemplate() {
      if (this.templateData.is_default === "") {
        this.templateData.is_default = 0;
      }

      if (this.editTemplateId !== null) {
        this.editTemplate();
      } else {
        emailTemplateCreate(
          localStorage.getItem("customer_id"),
          this.templateData
        )
          .then((res) => {
            //
            this.emailSidebar = false;
            this.$vs.notify({
              title: "Success",
              text: "Template Created Successfully",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
            });

            this.resetData();
            emailTemplateList(
              this.sorting_obj,
        'email_template',
        payload,
        localStorage.getItem("customer_id"),
        this.query_page.current_page,
        this.pageLimitSet
            )
              .then((res) => {
                this.templateList = res.data.data.template;
                this.query_page = res.data.data.meta;
              })
              .catch((e) => {});
          })
          .catch((e) => {
            this.$vs.notify({
              title: "Warning",
              text: "Something Went Wrong",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
            });
          });
      }
    },
    editTemplate() {
      if (
        this.templateData.is_default === null ||
        this.templateData.is_default === false
      ) {
        this.templateData.is_default = 0;
      }
      //
      emailTemplateEdit(
        localStorage.getItem("customer_id"),
        this.editTemplateId,
        this.templateData
      )
        .then((res) => {
          this.emailSidebar = false;
          this.$vs.notify({
            title: "Success",
            text: "Template Edited Successfully",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
          emailTemplateList(
            this.sorting_obj,
        'email_template',
        payload,
        localStorage.getItem("customer_id"),
        this.query_page.current_page,
        this.pageLimitSet
          )
            .then((res) => {
              this.templateList = res.data.data.template;
              this.query_page = res.data.data.meta;
              this.selected.length = 0;
              this.handleEditSidebar();
            })
            .catch((e) => {});
        })
        .catch((e) => {
          this.$vs.notify({
            title: "Warning",
            text: "Something Went Wrong",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
        });

      // this.templateData.platform_modules_id = ''
      setTimeout(() => {
        //Removing Email Template Id Used for edit template API
        this.editTemplateId = null;
      }, 2000);
    },

    cancelDeletePopup() {
      this.deletepopupflag = false;
      this.selected.length = 0;
    },
    cancelMultipleDeletePopup() {
      this.deletepopupflag1 = false;
      this.selected.length = 0;
    },
    templateDeletePopup(id) {
      this.deletepopupflag = true;
      this.deleteTemplateId = id;
    },
    deleteTemplate() {
      const payload = {
        ids: [this.deleteTemplateId],
      };
      emailTemplateDelete(localStorage.getItem("customer_id"), payload)
        .then((res) => {
          this.$vs.notify({
            title: "Success",
            text: "Template Deleted Successfully",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
          emailTemplateList(
            this.sorting_obj,
        'email_template',
        payload,
        localStorage.getItem("customer_id"),
        this.query_page.current_page,
        this.pageLimitSet
          )
            .then((res) => {
              this.templateList = res.data.data.template;
              this.query_page = res.data.data.meta;
              this.selected.length = 0;
              this.deletepopupflag = false;
              console.log(this.templateList)
            })
            .catch((e) => {});
        })
        .catch((e) => {
          this.$vs.notify({
            title: "Warning",
            text: "Something Went Wrong",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
        });
    },
    templateDeletePopup1() {
      this.deletepopupflag1 = true;
    },
    templateBulkDelete() {
      const BulkSelected = this.getSelectedRows();
      const deleting_ids = [];
      for (let i = 0; i < BulkSelected.length; i++) {
        deleting_ids.push(BulkSelected[i].email_template_id);
      }
      const payload = {
        ids: deleting_ids,
      };

      emailTemplateDelete(localStorage.getItem("customer_id"), payload)
        .then((res) => {
          //

          this.$vs.notify({
            title: "Success",
            text: "Templates Deleted Successfully",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
          this.query_page.current_page = this.query_page.next_page_url
            ? this.query_page.current_page
            : this.query_page.current_page - 1;

          emailTemplateList(
            this.sorting_obj,
        'email_template',
        payload,
        localStorage.getItem("customer_id"),
        this.query_page.current_page,
        this.pageLimitSet
          )
            .then((res) => {
              this.templateList = res.data.data.template;
              this.query_page = res.data.data.meta;
              this.deletepopupflag1 = false;
              this.selected.length = 0;
            })
            .catch((e) => {});
        })
        .catch((e) => {
          this.$vs.notify({
            title: "Warning",
            text: "Something Went Wrong",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
        });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.emailSidebar = false;
    this.emailViewSidebar = false;
    this.emailEditSidebar = false;
    this.deletepopupflag = false;
    this.deletepopupflag1 = false;
    setTimeout(() => {
      next();
    }, 0);
  },
};
</script>

<style>
.vuesax-app-is-ltr .vs-sidebar.vs-sidebar-position-right {
  z-index: 1000;
}
.unread {
  background-color: #fff5ec;
  font-weight: 500;
}
.read {
  background-color: transparent !important;
  font-weight: 500;
}
.email-table tr {
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
}
.email-card {
  position: relative;
}
.compose-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  /* background: #FF9F43 !important; */
  /* box-shadow: 0 8px 25px -8px rgba(255, 159, 67, 1) !important; */
}
.email-sidebar .vs-sidebar {
  max-width: 400px;
  margin-top: 107px;
}
.email-sidebar .sidebar-scrollable-form {
  height: calc(100% - 175px);
  overflow-y: auto;
  overflow-x: hidden;
}
.email-form input,
.email-form input:focus {
  border: none !important;
  box-shadow: none;
}
.sub-line {
  border: none !important;
  height: 40px;
}

@media (max-width: 360px) {
  .email-sidebar .vs-sidebar {
    max-width: 100%;
  }
}
.select_custom {
  height: 40px;
  border: none;
  background-color: white;
  border: 1px solid #cccccc;
  color: #787878;
  font-size: 14px;
  width: 100%;
  border-radius: 5px;
}

.code-hint {
  font-size: 8px;
  font-style: italic;
}
.field_code {
  cursor: pointer;
}
.field_code,
.field_description {
  justify-content: flex-start;
  display: flex;
  align-items: center;
  margin: 0%;
  background: #f6f6f6;
  width: 49% !important;
  word-break: break-all;
  padding: 10px;
  border-radius: 7px;
}
</style>